import React                  from 'react';
import { Helmet }             from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';

import { Block }              from '../../atoms/Layout/Block/Block';
import { Text }               from '../../atoms/Text/Text';
import { Game }               from '../../models/Game';
import Search             from '../../molecules/Search/Search';
import { environment }        from '../../config/environment';
import styles                 from './p404.css';

type P404TemplateProps = {
    games: Game[],
};

export class P404Template extends React.PureComponent<P404TemplateProps> {
    render() {
        const { games } = this.props;

        return (
            <Overlay>
                <Helmet
                    htmlAttributes = {{lang: 'en-US'}}
                    title = "Page Not Found - AARP Games"
                    meta = {[{ name: 'robots', content: 'noindex, follow' }]}
                    link = {[{ rel: 'canonical', href: environment.PROD_HOST + '/404'  }]}
                />
                <GlobalStyles />
                <Popup>
                    <Text1stBlock>
                        <Text size = "h1" align = "center">
                            😬
                        </Text>
                    </Text1stBlock>

                    <Block paddingB = "x3l">
                        <Text1st bold={true} size = "h3" align = "center">
                            "FOUR, OH FOUR"
                        </Text1st>
                    </Block>

                    <Block paddingB = "x3l">
                        <Dash />
                    </Block>

                    <Block paddingB = "x3l">
                        <Text2nd bold={true} size = "h1" align = "center">
                            This is not a glitch.
                            <br/>
                            We just can't find your page.
                        </Text2nd>
                    </Block>

                    <Block paddingB = "x4l">
                        <Text3rd bold={true} align = "center">
                            But you can see all of our games here.
                        </Text3rd>
                    </Block>

                    <PlayLink to = "/category/all-games">
                        <Text bold={true} size = "lg" align = "center">
                            FIND A GAME
                        </Text>
                    </PlayLink>

                    <SearchBox
                        games = {games}
                        placeholder = "Or click here to search..."
                    />
                </Popup>
            </Overlay>
        );
    }
}

const Overlay = (props: any) => <div className = {styles.overlay} {...props} />;
const Popup = (props: any) => <div className = {styles.popup} {...props} />;
const PlayLink = (props: any) => <RouterLink className = {styles.playLink} {...props} />;
const Dash = (props: any) => <div className = {styles.dash} {...props} />;
const Text1stBlock = (props: any) => <div className = {styles.text1stBlock} {...props} />;
const Text1st = (props: any) => <Text className = {styles.text1st} {...props} />;
const Text2nd = (props: any) => <Text className = {styles.text2nd} {...props} />;
const Text3rd = (props: any) => <Text className = {styles.Text3rd} {...props} />;
const SearchBox = (props: any) => <Search className = {styles.searchBox} {...props} />;

const GlobalStyles = (props: any) => (
    <style>
        {`
            body {
                background-image: url('/Pattern.png');
            }

            [data-header="true"] {
                display:  none !important;
            }
        `}
    </style>
);
